import { schema } from "normalizr";
import { arrayOfAttachments } from "./schema.attachments.jsx";

const note = new schema.Entity(`notes`);
const arrayOfNotes = [note];

note.define({
  attachments: arrayOfAttachments,
});

export { note, arrayOfNotes };
